import React from 'react';

import {
  AttendanceRules,
  BenefitsPurchaseTickets,
  HearingAndVisionImpairmentsV2,
  SaleCertificate,
  GitaFestival26
} from '../entities';

/**
 * Object structure
 *  
 * Example of object in array
  {
    component: <WeekendInParis2022 />,
    datesShow: {
      start: '2023-12-12T00:00:00',  // Year-Month-Day
      end: '2023-12-19T00:00:00',
    }
  }
  *
  * datesShow is not require. If datesShow not present than slide will be show.
 */
export const listSliders = [
  {
    component: <GitaFestival26 />,
    datesShow: {
      start: '2026-08-26T00:00:00',
      end: '2026-10-21T23:59:59',
    }
  },
  { component: <AttendanceRules /> },
  { component: <HearingAndVisionImpairmentsV2 /> },
  { component: <SaleCertificate /> },
  { component: <BenefitsPurchaseTickets /> },
]


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/config/listSliders.jsx